<template>
    <div class="generate-ppt view-report p-0">
        <div class="card mb-3 table-card" v-if="exports.length > 0">
            <div class="card-header">
                <div class="row align-items-end">
                    <div class="col-lg-8 col-12">
                        <h3 class="mt-2">Previous Presentations ({{ table_data.length }})</h3>
                        <p class="mb-0">Below is the list of previously generated presentations. When you copy one, it will take you back to the prior tab so that you can make any additional adjustments before exporting it.</p>
                    </div>
                    <div class="col-lg-4 d-none d-lg-block">
                        <div class="d-flex justify-content-end justify-self-end gap-2">
                            <div class="position-relative">
                                <input type="text" class="search-box form-control me-1 py-2" placeholder="Search by Presentation Name" aria-label="Search by Presentation Name" v-model="search_key" @input="searchPage()" autocomplete="one-time-code">
                                <i class="fa fa-search search-placeholder-icon" v-if="search_key === ''"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body p-0">
                <div class="table-width-responsive">
                    <table class="table table-with-pagination mb-0">
                        <thead>
                            <tr class="table-header-row">
                                <th v-for="label in labels" :key="label" @click="sortByKey(label)" :class="getClass(label)">
                                    <div class="d-flex flex-row">
                                        {{ propercase(label) }}
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key === label && sort_order === 'asc') ? 'sort-key-active' : ''" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key === label && sort_order === 'des') ? 'sort-key-active' : ''" alt="">
                                        </div>
                                    </div>
                                </th>
                                <th class="d-table-cell column-sort-disabled pe-3" width="1">
                                    <div class="d-flex flex-row">
                                        Actions
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="data in list_shown" :key="data.id">
                                <td v-for="label in labels" :key="label" :class="getClass(label)">
                                    <span v-if="label === 'sections'">
                                        {{ data[label].length }}
                                    </span>
                                    <span v-else-if="label === 'created_at'">
                                        {{ datetime(data[label]) }}
                                    </span>
                                    <span v-else-if="label === 'created_by'">
                                        <img :src="data.creator.image" :alt="data.creator.name" class="avatar rounded-circle me-2"> {{ data.creator.name }}
                                    </span>
                                    <span v-else>
                                        {{ propercase(data[label]) }}
                                    </span>
                                </td>
                                <td class="d-table-cell">
                                    <div class="dropdown d-flex justify-content-center">
                                        <button class="btn btn-white btn-icon-only-md" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false" aria-label="Button">
                                            <img class="icon" src="/img/icons/avid-icons/dots-vertical.svg" alt="">
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end w-auto">
                                            <a class="dropdown-item" target="_blank" :href="'/export/'+client.url+'/' + data.id">
                                                <img class="icon" src="/img/icons/avid-icons/file-download.svg" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Download Presentation" alt="">
                                                Download the Presentation
                                            </a>
                                            <a v-if="canExport('insights')" class="dropdown-item" href="#" @click.prevent="copyExport(data)">
                                                <img class="icon" src="/img/icons/avid-icons/document-copy.svg" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Clone Presentation" alt="">
                                                Duplicate the Presentation
                                            </a>
                                            <div v-if="canEdit('insights')" class="dropdown-divider"></div>
                                            <a v-if="canEdit('insights')" class="dropdown-item text-danger" href="#" @click.prevent="deleteExport(data.id)">
                                                <img class="icon red-icon" src="/img/icons/avid-icons/trash.svg" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Delete Presentation" alt="">
                                                Delete the Presentation
                                            </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot class="table-border-bottom-0">
                            <tr>
                                <td colspan="100%" class="py-0">
                                    <div class="table-pagination">
                                        <div class="table-pagination--group d-none d-md-flex">
                                            <div class="position-relative">
                                                <select class="form-select" name="num_per_page" id="num_per_page" v-model="num_per_page" @change="reloadPagination(table_data)" aria-label="Num Per Page">
                                                    <option value="5000">ALL</option>
                                                    <option v-for="num in num_per_page_options" :key="num" :value="num">{{ num }}</option>
                                                </select>
                                                <div class="select-display-text">
                                                    Showing {{ num_per_page === '5000' ? 'ALL' : num_per_page }}
                                                </div>
                                            </div>
                                            <div class="position-relative">
                                                <select class="form-select" name="num_per_page" id="num_per_page" v-model="num_per_page" @change="reloadPagination(table_data)" aria-label="Num Per Page">
                                                    <option value="5000">ALL</option>
                                                    <option v-for="num in num_per_page_options" :key="num" :value="num">{{ num }}</option>
                                                </select>
                                                <div class="select-display-text">
                                                    Showing {{ num_per_page === '5000' ? 'ALL' : num_per_page }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="table-pagination--group d-none d-lg-flex">
                                            {{ table_data.length === 0 ? '0' : item_interval }} of {{ table_data.length }}
                                        </div>

                                        <div class="table-pagination--group">
                                            <button v-if="page_count > 1" class="btn btn-secondary btn-icon-only-md me-1" @click="moveToPrevPage(table_data)" :disabled="page_index === 0">
                                                <img class="icon" src="/img/icons/avid-icons/chevron-left.svg" alt="">
                                            </button>

                                            <div class="d-flex page-selector" v-if="page_index_array.length <= 3">
                                                <button v-for="page in page_index_array" :key="page" class="btn btn-none btn-icon-only-md" :class="page === page_index + 1 ? 'current-page' : ''" @click="moveToPage(page, table_data)">
                                                    {{ page }}
                                                </button>
                                            </div>
                                            <div class="d-flex page-selector" v-else>
                                                <button v-for="page in page_index_array.slice(0,2)" :key="page" class="btn btn-none btn-icon-only-md" :class="page === page_index + 1 ? 'current-page' : ''" @click="moveToPage(page, table_data)">
                                                    {{ page }}
                                                </button>

                                                <button v-if="page_index > 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled>
                                                ...
                                                </button>
                                                <button v-if="page_index >= 2 && page_index < page_index_array.length - 1" class="btn btn-none btn-icon-only-md current-page">
                                                    {{ page_index + 1 }}
                                                </button>

                                                <button v-if="page_index < page_index_array.length - 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled aria-hidden="true">
                                                ...
                                                </button>
                                                <button :class="page_index === page_index_array.length - 1 ? 'current-page' : ''" class="btn btn-none btn-icon-only-md" @click="moveToPage(page_index_array.length, table_data)" :key="page_index_array.length">
                                                    {{ page_index_array.length }}
                                                </button>
                                            </div>

                                            <button v-if="page_count > 1" class="btn btn-secondary btn-icon-only-md ms-1" @click="moveToNextPage(table_data)" :disabled="page_index === page_count - 1">
                                                <img class="icon" src="/img/icons/avid-icons/chevron-right.svg" alt="">
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>                    
                </div>

            </div>
        </div>

        <h4 class="mt-3" v-if="exports.length === 0">No presentations have been generated yet.</h4>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import Swal from 'sweetalert2';
import { useNotifications } from '../../composables/useNotifications';
import tablePaginationMixin from '../../mixins/table_pagination';
import permissionsMixin from '../../mixins/permissions';

export default defineComponent({
    name: 'GeneratePresentationPreviousList',
    components: {
        Swal
    },
    setup() {
        const { showNotification } = useNotifications();
        return {
            showNotification
        };
    },
    props: {
        client: {
            type: Object,
            required: true
        },
        exports: {
            type: Array,
            required: true
        }
    },
    mixins: [tablePaginationMixin, permissionsMixin],
    data() {
        return {
            labels: ['name', 'sections', 'created_at', 'created_by'],
            search_key: '',
            table_data: [],
            list_shown: [],
            sort_key: 'created_at',
            sort_order: 'desc',
        };
    },
    beforeMount() {
        this.table_data = [...this.exports];
        this.reloadPagination(this.table_data);
    },
    mounted() {
        // Initialize tooltips
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

        for (let i = 0; i < tooltipTriggerList.length; i++) {
            (function(index) {
                tooltipTriggerList[index].addEventListener('click', function() {
                    tooltipList[index].hide();
                });
                tooltipTriggerList[index].addEventListener('mouseleave', function() {
                    tooltipList[index].hide();
                });
            })(i);
        }
    },
    methods: {
        getClass(label) {
            switch (label) {
                case 'name':
                    return 'd-table-cell';
                case 'sections':
                    return 'd-none d-sm-table-cell';
                case 'created_at':
                case 'created_by':
                    return 'd-none d-md-table-cell';
                default:
                    return 'd-table-cell';
            }
        },
        copyExport(data) {
            //Emit the function
            this.$emit('clone', data);
        },
        searchPage() {
            let filtered_list = [];

            if (this.search_key === '') {
                filtered_list = this.exports;
            } else {
                this.exports.forEach(page => {
                    if (page.name.toLowerCase().includes(this.search_key.toLowerCase())) {
                        filtered_list.push(page);
                    }
                });
            }
            this.table_data = filtered_list;
            this.reloadPagination(this.table_data);
        },
        sortByKey(key) {
            if (this.sort_key !== key) {
                this.sort_key = key;
                this.sort_order = 'asc'; // reset to ascending sorting order
            } else {
                this.sort_order = (this.sort_order === 'asc' ? 'des' : 'asc');
            }
            this.sortDataWithLabel();
        },
        sortDataWithLabel() {
            if (this.sort_order === 'asc') {
                this.table_data.sort((a, b) => (a[this.sort_key] > b[this.sort_key]) ? 1 : -1);
            } else {
                this.table_data.sort((a, b) => (a[this.sort_key] < b[this.sort_key]) ? 1 : -1);
            }
            this.reloadPagination(this.table_data);
        },
        deleteExport(id) {
            Swal.fire({
                title: "Are you sure you want to delete this presentation?",
                text: "The presentation will no longer be accessible to anyone else on the team once it is deleted.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete",
                customClass: {
                    popup: 'swal-warning'
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    window.axios.delete('/api/export/ppt/' + id)
                        .then(response => {
                            //Find the position of the deleted presentation
                            const pos = this.table_data.findIndex(e => e.id === id);
                            const presentationName = pos !== -1 ? this.table_data[pos]?.name : 'Your presentation';
                            this.table_data.splice(pos, 1);
                            this.reloadPagination(this.table_data);
                            
                            this.showNotification({
                                text: '<strong>' + presentationName + '</strong> was deleted!'
                            });
                        })
                        .catch(error => {
                            const presentationName = this.table_data.find(e => e.id === id)?.name || 'Your presentation';
                            this.showNotification({
                                text: 'Failed to delete <strong>' + presentationName + '</strong>. Please try again.',
                                type: 'error'
                            });
                        });
                }
            });
        }
    }
});
</script>